import { chooseService } from '../utils';
import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setCurrentCameras } from "../store/cameras/actions";
import { CameraDataInterface } from "../types";
import { ApplicationState } from "../store";
import { APIState } from "../store/API/types";
import { LayoutState } from "../store/layouts/types";
import { setInitialCameras } from '../store/layouts/actions';


const useSetCurrentCameras = () => {
  const {cameras, maps, webPages} = useSelector<ApplicationState, APIState>(state => state.API);
  const {currentLayout, currentLayoutChanged} = useSelector<ApplicationState, LayoutState>(state => state.layouts);
  const dispatch = useDispatch();
  const camerasIds = currentLayout ? Object.values(currentLayout.camerasIds) : currentLayout;

  useEffect(() => {
    if (!camerasIds) return;

    const defeniteCameras = chooseService(
      () => camerasIds.map((cameraId) => {
        const result = cameras?.find(({id}: CameraDataInterface) => cameraId === id);
        return result ? result : null;
      }),
      () => camerasIds.map((cameraId) => {
        // TODO rewrite types for camera, map and webpage result
        const camResult = cameras?.find(({id}: CameraDataInterface) => cameraId === id);
        const mapResult = maps?.find(({id}: CameraDataInterface) => cameraId === id)
        const webPageResult = webPages?.find(({id}: CameraDataInterface) => cameraId === id)
        return camResult ? camResult : mapResult ? mapResult : webPageResult ? webPageResult : null;
      })
    );

    // TODO check why cameras dispatched as object
    dispatch(setCurrentCameras({...defeniteCameras}));
    dispatch(setInitialCameras({...defeniteCameras}));
  }, [currentLayoutChanged]);

  return camerasIds
};

export default useSetCurrentCameras